module.exports = __webpack_public_path__ + "static/media/dr.749d9add.jpeg";